export const details = {
    address: '3554 Promenade Pkwy, Suite H, Lafayette, IN 47909',
    addressUrl: 'https://goo.gl/maps/H5qBPpj8JWCnBsz97',
    phone: '(765) 471-1100',
    phoneUrl: `tel:7654711100`,
    facebookUrl: `https://www.facebook.com/Innovativemedicine/`,
    twitterUrl: `https://twitter.com/med_innovative`,
    linkedinUrl: `https://www.linkedin.com/authwall?trk=bf&trkInfo=AQFQopiR_WwtNAAAAYM-Iqs4CxVN-lmuE-rLpaCboqkdaDqPsrbHvxPJq2_ZTykIc0sHOblIktnegL74lPXmBBxUt6nrRAXtZR0OojbvESbzzS8GbcqAdBJgovUMPeFVuUMYlgk=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fin%2Fcharles-turner-24011a101`,
};
